import React from "react"

import TopicLayout from "../shared/TopicLayout"
import {Arrow, Box, Diagram} from "../shared/Diagram"

export default function RequestResponseVsEvents() {
    return (
        <TopicLayout
            title="Request/response vs. events"
            intro="Two ways for one part of a system to tell another part that something needs to happen: ask directly and wait for an answer, or announce that something occurred and let interested parties react on their own schedule."
            diagram={
                <Diagram viewBox="0 0 560 200">
                    <text x={140} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Request/response</text>
                    <Box x={20} y={30} width={90} height={46} label="Client"/>
                    <Box x={170} y={30} width={90} height={46} label="Server"/>
                    <Arrow x1={110} y1={46} x2={170} y2={46} label="request"/>
                    <Arrow x1={170} y1={64} x2={110} y2={64} label="response"/>

                    <line x1={300} y1={10} x2={300} y2={190} stroke="var(--header-background)" opacity={0.25}/>

                    <text x={440} y={14} textAnchor="middle" fontSize={12} opacity={0.8}>Events</text>
                    <Box x={395} y={28} width={90} height={36} label="Producer"/>
                    <Box x={395} y={88} width={90} height={36} label="Event bus" accent/>
                    <Box x={330} y={148} width={85} height={34} label="Consumer A"/>
                    <Box x={460} y={148} width={85} height={34} label="Consumer B"/>
                    <Arrow x1={440} y1={64} x2={440} y2={88} label="publish"/>
                    <Arrow x1={415} y1={124} x2={380} y2={148} muted/>
                    <Arrow x1={465} y1={124} x2={495} y2={148} muted/>
                </Diagram>
            }
            useWhen={[
                'Request/response: the caller needs an immediate result, such as validating a login, and the operation is fast and reliable.',
                'Events: the caller can continue without the result, several consumers may react, or slow or unreliable side effects such as email and analytics should not block the request.'
            ]}
            tradeOff="Synchronous calls are easier to follow and debug, but tightly couple latency and availability: a slow dependency makes the caller slow. Events isolate failures and let consumers work independently, but introduce delayed consistency, retries, ordering, dead-letter handling and distributed tracing."
            ruleOfThumb="Default to request/response for the user-facing critical path when an immediate answer is required, and events for side effects of that action."
        />
    )
}
